export const PRODUCT_CAMERA_EVENT = "dworks:product-camera-result";
export const PRODUCT_CAMERA_KEY = "dworks.product-camera.v1";
const MAX_AGE = 30 * 60 * 1000;

export function readProductCameraDraft(ownerId, storage = localStorage, now = Date.now()) {
  try {
    const value = JSON.parse(storage.getItem(PRODUCT_CAMERA_KEY) || "null");
    if (!value) return null;
    if (!value.requestId || !value.ownerId || !value.draft?.f || now < value.createdAt || now - value.createdAt > MAX_AGE) {
      storage.removeItem(PRODUCT_CAMERA_KEY);
      return null;
    }
    return ownerId && value.ownerId !== ownerId ? null : value;
  } catch { return null; }
}

export function beginProductCamera(ownerId, draft, storage = localStorage) {
  if (!ownerId) throw new Error("로그인 상태를 확인해 주세요.");
  const value = { requestId: crypto.randomUUID(), ownerId, createdAt: Date.now(), draft, status: "pending" };
  try { storage.setItem(PRODUCT_CAMERA_KEY, JSON.stringify(value)); }
  catch { throw new Error("작성 내용을 임시 보관하지 못했습니다. 카메라를 열지 않았습니다. 갤러리 첨부를 이용해 주세요."); }
  return value.requestId;
}

export function completeProductCamera(requestId, result, storage = localStorage) {
  const value = readProductCameraDraft(null, storage);
  if (!value || value.requestId !== requestId || value.status !== "pending") return false;
  const next = { ...value, ...result };
  try { storage.setItem(PRODUCT_CAMERA_KEY, JSON.stringify(next)); }
  catch {
    storage.setItem(PRODUCT_CAMERA_KEY, JSON.stringify({ ...value, status: "error", message: "촬영 사진을 임시 보관하지 못했습니다. 작성 내용은 복원했습니다. 갤러리 첨부를 이용해 주세요." }));
  }
  return true;
}

export function clearProductCameraDraft(requestId, storage = localStorage) {
  const value = readProductCameraDraft(null, storage);
  if (!requestId || value?.requestId === requestId) storage.removeItem(PRODUCT_CAMERA_KEY);
}
